import React from 'react';
import TextField from '../../../../components/form/text-field';
import FormError from '../../../../components/form/error/error';
import './contact-form.css';

export const ContactForm = (props) => {
  const {
    authorableContent: {
      firstName,
      contactField,
      lastName,
      email,
      accountNumber,
      abnNumber,
      billingAddress,
    },
    contactFormError,
    contactFormValue,
    onChange,
    onBlur,
  } = props;
  console.log(props);
  return (
    <div className="contact-form">
      <div className="row">
        <div className="input-section col-sm-12 col-md-4 pl-sm-0">
          <div className="contact-field-description">{firstName.label}</div>
          <TextField
            id="firstName"
            value={contactFormValue.firstName}
            placeholder={firstName.placeholder}
            onChange={onChange}
            onBlur={onBlur}
          />
          {contactFormError.firstName && <FormError errorText={firstName.errorText} />}
        </div>
        <div className="input-section col-sm-12 col-md-4 pl-sm-0">
          <div className="contact-field-description">{lastName.label}</div>
          <TextField
            id="lastName"
            value={contactFormValue.lastName}
            placeholder={lastName.placeholder}
            onChange={onChange}
            onBlur={onBlur}
          />
          {contactFormError.lastName && <FormError errorText={lastName.errorText} />}
        </div>
        <div className="input-section col-sm-12 col-md-4 pl-sm-0">
          <div className="contact-field-description">{contactField.label}</div>
          <TextField
            id="contactField"
            value={contactFormValue.contactField}
            placeholder={contactField.placeholder}
            onChange={onChange}
            onBlur={onBlur}
          />
          {contactFormError.contactField && <FormError errorText={contactField.errorText} />}
        </div>
      </div>
      <div className="row">
        <div className="input-section col-sm-12 col-md-4 pl-sm-0">
          <div className="contact-field-description">{email.label}</div>
          <TextField
            id="email"
            value={contactFormValue.email}
            placeholder={email.placeholder}
            onChange={onChange}
            onBlur={onBlur}
          />
        </div>
        <div className="input-section col-sm-12 col-md-4 pl-sm-0">
          <div className="contact-field-description">{accountNumber.label}</div>
          <TextField
            id="accountNumber"
            value={contactFormValue.accountNumber}
            placeholder={accountNumber.placeholder}
            onChange={onChange}
            onBlur={onBlur}
          />
        </div>
        <div className="input-section col-sm-12 col-md-4 pl-sm-0">
          <div className="contact-field-description">{abnNumber.label}</div>
          <TextField
            id="abnNumber"
            value={contactFormValue.abnNumber}
            placeholder={abnNumber.placeholder}
            onChange={onChange}
            onBlur={onBlur}
          />
        </div>
      </div>
      <div className="row">
        <div className="input-section col-sm-12 col-md-4 pl-sm-0">
          <div className="contact-field-description">{billingAddress.label}</div>
          <TextField
            id="billingAddress"
            value={contactFormValue.billingAddress}
            placeholder={billingAddress.placeholder}
            onChange={onChange}
            onBlur={onBlur}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactForm;

